var r = Array.prototype.map,
  t = Array.isArray,
  n = Object.prototype.toString;
function e(r) {
  return !!("" === r || r && r.charCodeAt && r.substr);
}
function o(r) {
  return t ? t(r) : "[object Array]" === n.call(r);
}
function a(r) {
  return r && "[object Object]" === n.call(r);
}
function i(r, t) {
  var n;
  for (n in r = r || {}, t = t || {}) t.hasOwnProperty(n) && null == r[n] && (r[n] = t[n]);
  return r;
}
function s(t, n, e) {
  if (!t) return [];
  if (r && t.map === r) return t.map(n, e);
  var o,
    a = [],
    i = 0;
  for (i = 0, o = t.length; i < o; i++) a[i] = n.call(e, t[i], i, t);
  return a;
}
var c = {
  settings: {
    currency: {
      symbol: "$",
      format: "%s%v",
      decimal: ".",
      thousand: ",",
      precision: 2,
      grouping: 3
    },
    number: {
      precision: 0,
      grouping: 3,
      thousand: ",",
      decimal: "."
    }
  }
};
function u(r, t) {
  return void 0 === t && (t = 0), r = Math.round(Math.abs(r)), isNaN(r) ? t : r;
}
var l = function r(t, n) {
    if (o(t)) return s(t, function (t) {
      return r(t, n);
    });
    if ("number" == typeof (t = t || 0)) return t;
    n = n || c.settings.number.decimal;
    var e = new RegExp("[^0-9-" + n + "]", ["g"]),
      a = parseFloat(("" + t).replace(/\((?=\d+)(.*)\)/, "-$1").replace(e, "").replace(n, "."));
    return isNaN(a) ? 0 : a;
  },
  p = function (r, t) {
    t = u(t, c.settings.number.precision);
    var n = Number(l(r) + "e" + t),
      e = Math.round(n);
    return Number(e + "e-" + t).toFixed(t);
  },
  f = {
    name: "currency",
    symbol: "",
    thousandsSeparator: ".",
    fractionCount: 0,
    fractionSeparator: ",",
    symbolPosition: "front",
    symbolSpacing: !0,
    avoidEmptyDecimals: void 0
  },
  m = {
    install: function (r, t) {
      var n = function (t) {
        null == t && (t = {});
        var n = i(t, f),
          m = n.name,
          y = function (r, t) {
            if (null == r) return {};
            var n,
              e,
              o = {},
              a = Object.keys(r);
            for (e = 0; e < a.length; e++) t.indexOf(n = a[e]) >= 0 || (o[n] = r[n]);
            return o;
          }(n, ["name"]),
          d = function (r, t, n, f, m, d, v, b) {
            var g = i({
              symbol: t,
              thousandsSeparator: n,
              fractionCount: f,
              fractionSeparator: m,
              symbolPosition: d,
              symbolSpacing: v,
              avoidEmptyDecimals: b
            }, y);
            "object" == typeof t && (g = i(t, y));
            var h = 0,
              S = "-" === String(r).charAt(0);
            S && (r = String(r).slice(1));
            var A,
              C = parseFloat(r);
            return isNaN(C) || (h = C), A = "front" === g.symbolPosition ? g.symbolSpacing ? "%s %v" : "%s%v" : g.symbolSpacing ? "%v %s" : "%v%s", g.fractionCount > 0 && (r = p(r, g.fractionCount)), h = function r(t, n, f, m, y, d, v) {
              if (o(t)) return s(t, function (t) {
                return r(t, n, f, m, y, d, v);
              });
              t = l(t);
              var b = i(a(n) ? n : {
                  symbol: n,
                  precision: f,
                  thousand: m,
                  decimal: y,
                  format: d,
                  avoidEmptyDecimals: v
                }, c.settings.currency),
                g = function (r) {
                  var t = c.settings.currency.format;
                  return "function" == typeof r && (r = r()), e(r) && r.match("%v") ? {
                    pos: r,
                    neg: r.replace("-", "").replace("%v", "-%v"),
                    zero: r
                  } : r && r.pos && r.pos.match("%v") ? r : e(t) ? c.settings.currency.format = {
                    pos: t,
                    neg: t.replace("%v", "-%v"),
                    zero: t
                  } : t;
                }(b.format);
              return (t > 0 ? g.pos : t < 0 ? g.neg : g.zero).replace("%s", b.symbol).replace("%v", function r(t, n, e, f, m) {
                if (o(t)) return s(t, function (t) {
                  return r(t, n, e, f, m);
                });
                t = l(t);
                var y = i(a(n) ? n : {
                    precision: n,
                    thousand: e,
                    decimal: f
                  }, c.settings.number),
                  d = u(y.precision),
                  v = t < 0 ? "-" : "",
                  b = parseInt(p(Math.abs(t || 0), d), 10) + "",
                  g = b.length > 3 ? b.length % 3 : 0,
                  h = "";
                return d && (h = y.decimal + p(Math.abs(t), d).split(".")[1], void 0 !== m && parseInt(p(Math.abs(t || 0), 1), 10) == t && (h = "" === m ? "" : y.decimal + m)), v + (g ? b.substr(0, g) + y.thousand : "") + b.substr(g).replace(/(\d{3})(?=\d)/g, "$1" + y.thousand) + h;
              }(Math.abs(t), u(b.precision), b.thousand, b.decimal, b.avoidEmptyDecimals));
            }(r, {
              format: A,
              symbol: g.symbol,
              precision: g.fractionCount,
              thousand: g.thousandsSeparator,
              decimal: g.fractionSeparator,
              avoidEmptyDecimals: g.avoidEmptyDecimals
            }), S && (h = "-" + h), h;
          };
        r.filter(m, d), r.prototype["$" + m] = {
          setConfig: function (r) {
            y = i(r, f);
          },
          getConfig: function () {
            return y;
          },
          format: d
        };
      };
      Array.isArray(t) ? t.forEach(function (r) {
        return n(r);
      }) : n(t);
    }
  };
export default m;